import type { StatCardModel } from '@/types/stats';
import { StatCard } from '@/components/primitives/StatCard';
import styles from './StatCardGrid.module.css';

type StatCardTuple3 = readonly [StatCardModel, StatCardModel, StatCardModel];
type StatCardTuple4 = readonly [StatCardModel, StatCardModel, StatCardModel, StatCardModel];
type StatCardTuple5 = readonly [
  StatCardModel,
  StatCardModel,
  StatCardModel,
  StatCardModel,
  StatCardModel,
];

interface StatCardGridProps {
  cards: StatCardTuple3 | StatCardTuple4 | StatCardTuple5;
}

export function StatCardGrid({ cards }: StatCardGridProps) {
  return (
    <div className={styles.grid} data-testid="stat-card-grid" data-count={cards.length}>
      {cards.map((card) => (
        <StatCard
          key={card.label}
          label={card.label}
          value={card.value}
          sublabel={card.sublabel}
          trend={card.trend}
          icon={card.icon}
        />
      ))}
    </div>
  );
}
